import Modal from '@components/v2/ui/Modal/Modal';
import { Grid } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../utils/testIds/catalog.testIds';
import {
  CatalogCreationAccessCatalogDates,
  CatalogCreationAccessEntitiesToAdd,
  CatalogCreationAccessFieldName,
} from '../catalogCreationAccess.types';
import { useCatalogCreationAccessAddModal } from '../hooks/useCatalogCreationAccessAddModal';
import CatalogCreationAccessAddDateField from './CatalogCreationAccessAddDateField';
import CatalogCreationAccessAddEntitiesField from './CatalogCreationAccessAddEntitiesField';

interface CatalogCreationAccessAddModalProps {
  field: CatalogCreationAccessFieldName;
  catalogDates: CatalogCreationAccessCatalogDates;
  listedEntityIds: string[];
  catalogId?: string;
  onClose: () => void;
  onConfirm: (entitiesToAdd: CatalogCreationAccessEntitiesToAdd) => void;
}

const CatalogCreationAccessAddModal = ({
  field,
  catalogDates,
  listedEntityIds,
  catalogId,
  onClose,
  onConfirm,
}: CatalogCreationAccessAddModalProps) => {
  const {
    config,
    control,
    selectedOptions,
    isConfirmDisabled,
    startDateHelperText,
    endDateHelperText,
    handleChangeSelectedOptions,
    handleConfirm,
  } = useCatalogCreationAccessAddModal({ field, catalogDates, catalogId, onConfirm });

  return (
    <Modal
      isOpen
      size="expanded"
      testId={CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_MODAL}
      header={{ title: config.title }}
      onClose={onClose}
      footer={{
        primaryAction: {
          isDisabled: isConfirmDisabled,
          label: LangEnum.GLOBAL_ADD,
          testId: CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_CONFIRM,
          onClick: handleConfirm,
        },
        secondaryAction: {
          label: LangEnum.GLOBAL_CANCEL_LABEL,
          testId: CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_CANCEL,
          onClick: onClose,
        },
      }}
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid size={12}>
          <CatalogCreationAccessAddEntitiesField
            control={control}
            config={config}
            selectedOptions={selectedOptions}
            listedEntityIds={listedEntityIds}
            onChangeSelectedOptions={handleChangeSelectedOptions}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <CatalogCreationAccessAddDateField
            control={control}
            name="startDate"
            label={LangEnum.GLOBAL_INITIAL_DATE}
            helperText={startDateHelperText}
            testId={CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_START_DATE}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <CatalogCreationAccessAddDateField
            control={control}
            name="endDate"
            label={LangEnum.GLOBAL_FINAL_DATE}
            helperText={endDateHelperText}
            testId={CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_END_DATE}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default CatalogCreationAccessAddModal;
